import { Button, useFocus } from '@netapp/bxp-design-system-react';
import classNames from "classnames";
import { leftNav as i18nNamespace } from "../../../../../i18n/namespace";
import React, { forwardRef, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Measure from 'react-measure';
import { NavLink } from 'react-router-dom';
import usePermission from 'utils/usePermission';
import styles from "./CategoriesNav.module.scss";

const ServiceNavItems = ({ selectedService, selectedTab }) => {
    const { t } = useTranslation(i18nNamespace);

    /************** For accessibility ****************/
    const { onFocus, onBlur } = useFocus();
    const hasPermission = usePermission();
    let isPermissionGranted = true;
    if (selectedService?.permissionKeys) {
        isPermissionGranted = hasPermission({
            permissionKey: selectedService?.permissionKeys
        });
    }

    if (isPermissionGranted) {
        return <>
            <div className={styles['service']} onFocus={onFocus}
                onBlur={onBlur}
            >
                {t(selectedService?.name)}
            </div>
            {selectedService?.subTabs && selectedService?.subTabs.length > 0 && <div className={styles['service-menu-item-container']}>
                {selectedService?.subTabs.map((subTab, index) => {
                    const isActive = selectedTab ? selectedTab?.to === subTab.to : index === 0;
                    return <NavLink
                        onFocus={onFocus}
                        to={selectedService?.to + subTab.to}
                        data-nav={selectedService?.key + `/${subTab.label}`}
                        className={classNames(styles['service-menu-item'], { [styles['service-active']]: isActive })}
                        key={selectedService?.key + `/${subTab.label}`}
                        exact={!subTab.to}
                    >
                        {t(subTab.label)}
                    </NavLink>
                })}
            </div>}
        </>
    } else {
        return <Button variant="text"
            tooltip={t('user_do_not_have_access')}
            disabled={true}
            className={classNames(styles.disabledMenu)}
        >
            {t(selectedService?.name)}
        </Button>
    }
}

const SelectedServiceNav = React.memo(forwardRef((props, lastNavRef) => {
    const ref = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);
    const { t } = useTranslation(i18nNamespace);

    return <div className={styles.wrapper}>
        <div
            ref={ref}
            className={classNames(styles.container, { [styles['has-scroll']]: hasScroll })}
            style={{position: "absolute"}}
        >
            <Measure
                bounds
                onResize={contentRect => {
                    setHasScroll(contentRect.bounds.height > ref?.current?.clientHeight);
                }}
            >
                {({ measureRef }) => (
                    <div ref={measureRef}>
                        <ServiceNavItems selectedService={props.selectedService} selectedTab={props.selectedSubTab} />
                    </div>
                )}
            </Measure>
        </div>
        <button ref={lastNavRef} tabIndex={-1} aria-label={t("press_tab_key")}></button>
    </div>
}));

export default SelectedServiceNav;